declare global {
    interface Window {
        adobeDataLayer: {
            event: string,
            quoteInfo?: any
        }[];
    }
}

export function pushEventToAdobeDataLayer(eventName: string): void {
    const key = 'adobeDataLayer';

    window[key] = window[key] || [];
    window[key].push({
        event: eventName
    });
}

export function pushEventToAdobeDataLayerTimeout(timeout: number, eventName: string): any {
    return setTimeout(() => {
        pushEventToAdobeDataLayer(eventName);
    }, timeout);
}
